import { defineMessages } from 'react-intl';

const messages = defineMessages({
  toogle: {
    id: 'toogle.lightDarkMode',
    defaultMessage: `Toggle between light and dark mode`,
  },
});

export default messages;
